/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignRight = createReactComponent("outline", "layout-align-right", "IconLayoutAlignRight", [["path", { "d": "M20 4l0 16", "key": "svg-0" }], ["path", { "d": "M4 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

export { IconLayoutAlignRight as default };
//# sourceMappingURL=IconLayoutAlignRight.mjs.map
